module.exports = __webpack_public_path__ + "img/pinstle-logo.3c85c530.png";